export default __webpack_public_path__ + "static/media/forestly-expl-03_EN.3bd892cb.png";